import { useIntl } from 'lib/intl-utils'
import { DocumentList } from 'lib/dto'
import { useNotification } from './NotificationArea'
import { useStateFromLocalStorage } from 'lib/hooks'
import { useCallback, useEffect } from 'react'
import { useUserContext } from 'lib/context'
import dayjs from 'dayjs'
import { atom, useSetAtom } from 'jotai'

export const documentsAtom = atom<DocumentList | null>(null)

const DocumentNotifier = () => {
  const ctx = useUserContext()
  const { t } = useIntl()
  const showNotification = useNotification()
  const [lastSeenDocumentCreatedAt, setLastSeenDocumentCreatedAt] = useStateFromLocalStorage(
    'lastSeenDocumentCreatedAt',
    undefined
  )
  const setDocuments = useSetAtom(documentsAtom)

  const checkForNewDocuments = useCallback(async () => {
    const documents = await ctx.getDocumentList(1, 10)
    setDocuments(documents)

    if (
      documents?.items &&
      documents.items.length > 0 &&
      ((!lastSeenDocumentCreatedAt && dayjs().diff(documents.items[0].createdAt, 'day') < 7) ||
        (lastSeenDocumentCreatedAt &&
          dayjs(documents.items[0].createdAt) > dayjs(lastSeenDocumentCreatedAt)))
    ) {
      showNotification({
        type: 'info',
        title: t`documents.new_document`,
        message: t`documents.new_document_explanation`,
        primaryLink: {
          title: t`documents.view_documents`,
          props: { href: `/settings/documents/` },
        },
      })
    }
    if (documents?.items && documents.items.length > 0) {
      setLastSeenDocumentCreatedAt(documents.items[0].createdAt)
    }
  }, [ctx, lastSeenDocumentCreatedAt, showNotification, t])

  useEffect(() => {
    if (lastSeenDocumentCreatedAt === undefined) return
    checkForNewDocuments()
  }, [lastSeenDocumentCreatedAt, checkForNewDocuments])

  return null
}

export default DocumentNotifier
